import { empty } from "ramda";

export const layerNames = {
  customers: "customers",
  wasteWater: "waste-water",
  bom: "bom",
  dams: "dams",
  sewerZones: "sewer-zones",
  poor_signal_strength: "poor_signal_strength",
  moderate_signal_strength: "moderate_signal_strength",
  strong_signal_strength: "strong_signal_strength",
  empty_pipe: "empty_pipe",
  low_battery: "low_battery",
  high_pressure: "high_pressure",
  low_pressure: "low_pressure",
};
